// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clock from "@insite/mobius/Icons/Clock";
import { searchHistoryStyles } from "@tps/Overrides/Widgets/Header/SearchHistory";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

searchHistoryStyles.headerText = {
    weight: "bold",
    size: 14,
    css: css`
        text-align: left;
        margin-bottom: 10px;
        display: block;
    `,
};

searchHistoryStyles.wrapper = {
    css: css`
        width: 250px;
        padding: 13px;
        text-align: left;

        ${xScreen("lte", "md")} {
            width: 100%;
            padding-right: 0;
        }
    `,
};

searchHistoryStyles.itemWrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        button {
            max-width: calc(100% - 28px);
        }
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 18,
    css: css`
        margin-right: 10px;
    `,
};

searchHistoryStyles.link = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
            &&& {
                color: ${color("text.main")};
            }
        `,
    },
};

searchHistoryStyles.focusedLink = {
    typographyProps: {
        color: "text.main",
        size: 12,
        lineHeight: "13px",
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
        `,
    },
};

searchHistoryStyles.clearLink = {
    color: "primary",
    typographyProps: {
        size: 12,
        css: css`
            width: auto;
            text-align: left;
            margin-top: 15px;
        `,
    },
};